import * as React from 'react'

import { cn } from '@/shared/ui/cn'
import { Skeleton } from '@/shared/ui/primitives'

type DataTableSkeletonProps = {
  rows?: number
  columns?: number
  className?: string
}

function DataTableSkeleton({
  rows = 8,
  columns = 5,
  className,
}: DataTableSkeletonProps) {
  const rowCount = Math.max(0, Math.floor(rows))
  const columnCount = Math.max(0, Math.floor(columns))

  return (
    <div
      data-slot="data-table-skeleton"
      role="status"
      aria-label="Loading..."
      aria-busy="true"
      className={cn('flex flex-col gap-2', className)}
    >
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          data-slot="data-table-skeleton-row"
          className="flex gap-2"
        >
          {Array.from({ length: columnCount }).map((_, colIndex) => (
            <Skeleton key={colIndex} className="h-10 flex-1" />
          ))}
        </div>
      ))}
    </div>
  )
}

export { DataTableSkeleton }
export type { DataTableSkeletonProps }
